import { Command } from "./Command";
import { GamePlay } from "../model/game-play";
import { HomeAway } from "../model/home-away";
import { calculateYardLine, getDistance } from "../helpers/distance";

export class SetPenaltyCommand implements Command {

  constructor(
    private gamePlay: GamePlay,
    private penaltyForHome: boolean,
    private penaltyYard: number,
    private yardSpot: string,
  ) {
  }

  execute() {
    console.log('COMMAND SetPenaltyCommand', this.gamePlay, this.penaltyYard, this.penaltyForHome, this.yardSpot)
    // TODO devrait être d'autres commande

    // penaltyYard === 0 peut vouloir dire deux choses différentes :
    // - une pénalité "spot foul" (ex: 1 verge près du but) avec un yardSpot réel fourni -> calculer la distance
    // - un résultat sans verges (firstDown / loosDown / repeatLastDown) sans yardSpot -> 0 verge, ne rien calculer
    this.gamePlay.penYards = (this.penaltyYard === 0 && this.yardSpot !== '')
      ? this.calculatePenaltyYards(this.penaltyYard, this.yardSpot)
      : this.penaltyYard;

    // FIXME Hack car SetGainCommand fonctionne pas pour ODK kick
    //   Sébas : Exact pour les kick on calcul pas le setGainCommand.
    //           Mais si on voulait calculé les yarding des penalité il faut ajouter les GN/LS de la pénalité
    //           quand elle arrive sur les Kick. Pe faire une commande ?
    this.gamePlay.gnLs = this.gamePlay.penYards;

    if (this.gamePlay.penYards < 0) {
      // On met toujours le nombre en positif
      this.gamePlay.penYards = this.gamePlay.penYards * -1;
    }

    this.gamePlay.penTeam = this.penaltyForHome ? HomeAway.Home : HomeAway.Away;
  }

  calculatePenaltyYards(penaltyYard: number, yardSpot: string): number {
    const playSpot = calculateYardLine(this.gamePlay.yardLine, this.gamePlay.gnLs!);
    return getDistance(playSpot, yardSpot);
  }
}
